import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

type RecordSettings = Record<string, unknown>;

type ModelModule = { settings?: RecordSettings };

const context = import.meta.webpackContext('../models', {
  recursive: false,
  regExp: /\.js$/,
  mode: 'sync',
});

const modules: Record<string, ModelModule> = Object.fromEntries(
  context.keys().map((key) => {
    const recordType = key.replace(/^\.\//, '').replace(/\.js$/, '');

    return [recordType, context(key) as ModelModule];
  }),
);

export function getRecordSettings<T = unknown>(
  record: unknown,
  key: string,
): T | undefined {
  const recordType = getRecordType(record);
  const value = modules[recordType]?.settings?.[key];

  if (typeof value === 'function') {
    return (value as (record: unknown) => T)(record);
  }

  return value as T | undefined;
}
